import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from 'src/app/core/helpers/auth.service';
import { CoreService } from 'src/app/core/helpers/core.service';

@Component({
  selector: 'loyaltic-reward-teasers',
  templateUrl: './reward-teasers.component.html',
  styleUrls: ['./reward-teasers.component.scss']
})
export class RewardTeasersComponent implements OnInit, OnDestroy {
  readonly fallbackImage = 'assets/images/reward-placeholder.svg';
  readonly autoSlideDelay = 5000;
  readonly slideTransitionDelay = 180;

  culture = '';
  userId = '';
  rewards: any[] = [];
  activeIndex = 0;
  autoSlideInterval: any;
  slideTransitionTimeout: any;
  cardAnimationClass = 'reward-teasers__card--fade-in';

  constructor(
    private coreService: CoreService,
    private authService: AuthService,
    private translate: TranslateService,
    private router: Router
  ) {
    this.culture = this.translate.getDefaultLang();
    if (this.authService.IsLoggedIn()) {
      this.userId = this.authService.getUserId();
    }
  }

  ngOnInit() {
    this.getRewards();
  }

  ngOnDestroy() {
    this.stopAutoSlide();
    this.stopSlideTransition();
  }

  get currentReward(): any | null {
    if (!this.rewards.length) {
      return null;
    }

    return this.rewards[this.activeIndex];
  }

  get hasMultipleRewards(): boolean {
    return this.rewards.length > 1;
  }

  getRewards() {
    this.coreService.getRewards(this.culture, this.userId).then((response: any) => {
      this.rewards = response && response.result && response.result.rewards
        ? response.result.rewards
        : [];
      this.activeIndex = 0;
      this.startAutoSlide();
    });
  }

  showPreviousReward() {
    if (!this.rewards.length) {
      return;
    }

    this.setActiveIndex((this.activeIndex - 1 + this.rewards.length) % this.rewards.length);
    this.restartAutoSlide();
  }

  showNextReward() {
    if (!this.rewards.length) {
      return;
    }

    this.setActiveIndex((this.activeIndex + 1) % this.rewards.length);
    this.restartAutoSlide();
  }

  goToRewards() {
    this.router.navigate(['/rewards']);
  }

  startAutoSlide() {
    var self = this;

    this.stopAutoSlide();

    if (!this.hasMultipleRewards) {
      return;
    }

    this.autoSlideInterval = setInterval(function() {
      self.setActiveIndex((self.activeIndex + 1) % self.rewards.length);
    }, this.autoSlideDelay);
  }

  restartAutoSlide() {
    this.startAutoSlide();
  }

  stopAutoSlide() {
    if (this.autoSlideInterval) {
      clearInterval(this.autoSlideInterval);
      this.autoSlideInterval = null;
    }
  }

  stopSlideTransition() {
    if (this.slideTransitionTimeout) {
      clearTimeout(this.slideTransitionTimeout);
      this.slideTransitionTimeout = null;
    }
  }

  setActiveIndex(index: number) {
    if (index === this.activeIndex || !this.rewards.length) {
      return;
    }

    this.stopSlideTransition();
    this.cardAnimationClass = 'reward-teasers__card--fade-out';

    this.slideTransitionTimeout = setTimeout(() => {
      this.activeIndex = index;
      this.cardAnimationClass = 'reward-teasers__card--fade-in';
      this.slideTransitionTimeout = null;
    }, this.slideTransitionDelay);
  }
}
